<template>
  <div :id="!this.isIE() ? 'seq_calendrier' : 'ie'">
    <div v-if="!this.isIE()">
      <div class="infos--date">
        <b-link v-b-modal.modal-select-date>
          <span class="encart--sherpa">Sherpa</span>
          <span class="encart--nomMag">{{ nomMagasin }}</span>
        </b-link>
        <b-link v-b-modal.modal-backPortail>
          <span class="d-block w-100 encart--changeDate">{{
            $t("bandeau.changerStation")
          }}</span>
        </b-link>
        <b-link v-b-modal.modal-select-date>
          <h4>
            <i class="far fa-clock"></i>
            {{ modeSelected }}
            <!-- {{ $t('bandeau.dateLivraison') }} -->
          </h4>
          <span class="encart--chosenDate">{{ dateAndHourFormat }}</span>
          <span class="encart--changeDate">{{ $t("bandeau.changer") }}</span>
        </b-link>
      </div>

      <b-modal
        id="modal-backPortail"
        ref="modal-backPortail"
        :title="quitPresta"
        size="xl"
        centered
        scrollable
        @show="loadModal()"
        hide-footer
      >
        <template v-slot>
          <div class="d-block text-center">
            <p>{{ $t("alert.quitPresta") }}</p>
          </div>
          <b-button
            size="xl"
            variant="outline-secondary"
            @click="hideModal()"
            class="m-2"
            >{{ $t("alert.cancel") }}</b-button
          >
          <b-button size="xl" variant="primary" @click="leavePresta()">{{
            $t("alert.accept")
          }}</b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-select-date"
        ref="modal-select-date"
        :title="formatedMagasinTitle"
        size="xl"
        centered
        static
        @show="loadModal()"
      >
        <template v-slot:modal-title>
          <div class="modal-title">
            <div class="supermarket-title">{{ formatedMagasinTitle }}</div>
            <div class="sentence-title" v-html="sentenceTitle"></div>
          </div>
        </template>
        <div class="row">
          <div class="col-md-8">
            <FullCalendar
              defaultView="dayGridMonth"
              themeSystem="bootstrap4"
              aspectRatio="2.5"
              v-bind:showNonCurrentDates="false"
              :header="header"
              :plugins="calendarPlugins"
              :firstDay="firstDay"
              :locale="locale"
              :selectable="selectable"
              :events="events"
              :defaultDate="defaultDate"
              :longPressDelay="1"
              @dateClick="handleDateClick"
              @select="handleSelect"
              @datesRender="handleNewRender"
              ref="fullCalendar"
            />
          </div>
          <div class="col-md-4">
            <div class="bouton-drive" v-if="orderToday" @click="goToToday">
              <div class="bouton-drive-content d-flex">
                <img
                  class="titre-picto align-self-start"
                  :src="imgurl + 'drive.png'"
                />
                <span class="texte-bouton-drive align-self-center">
                  <b>{{ $t("calendrier.bouton.txt") }}</b>
                  <span
                    class="drive-last-horaire"
                    v-if="driveLastHoraireRetrait !== null"
                  >
                    <br />
                    {{ dernierHorairePossibleDrive }}
                  </span>
                </span>
              </div>
            </div>
            <div class="infos-date">
            <div class="zone_livraison" v-if="!retrait && !livraisonPossibleJour">{{ livraisonStation }}</div>
              <div class="infos-retrait" v-if="retrait">
                <div class="infos-retrait-titre">
                  <h5>
                    <img class="titre-picto" :src="imgurl + 'retrait.png'" />
                    {{ $t("infos.retrait.titre") }}
                  </h5>
                </div>
                <div class="infos-retrait-infos">
                  <span v-if="fraisPreparationRetrait !== null">
                    {{ $t("infos.retrait.fraisPrepa") }}
                    <span class="info-bold">{{
                      fraisPreparationRetraitFormated
                    }}</span>
                    <br />
                  </span>
                  <span v-if="fraisRetrait !== null">
                    {{ $t("infos.retrait.fraisRetrait") }}
                    <span class="info-bold">{{ fraisRetraitFormated }}</span>
                  </span>
                </div>
              </div>
              <div class="infos-livraison" v-if="livraisonPossibleJour">
                <div class="infos-livraison-titre">
                  <h5>
                    <img class="titre-picto" :src="imgurl + 'livraison.png'" />
                    {{ $t("infos.livraison.titre") }}
                  </h5>
                </div>
                <div class="infos-livraison-infos">
                  <span v-if="periodeGratuiteStart !== null">
                    <span class="info-bold">{{ periodeGratuiteFormated }}</span>
                    <br />
                  </span>
                  <span v-if="fraisPreparationLivraison !== null">
                    {{ $t("infos.livraison.fraisPrepa") }}
                    <span class="info-bold">{{
                      fraisPreparationLivraisonFormated
                    }}</span>
                    <br />
                  </span>
                  <span v-if="fraisLivraison !== null">
                    {{ $t("infos.livraison.fraisLivraison") }}
                    <span class="info-bold">{{ fraisLivraisonFormated }}</span>
                    <br />
                  </span>
                  <span v-if="livraisonGratuiteDes !== null">
                    {{ $t("infos.livraison.freeDeliveryFrom") }}
                    <span class="info-bold">{{
                      livraisonGratuiteDesFormated
                    }}</span>
                    <br />
                  </span>
                  <span v-if="montantMinimumPourLivraison !== null">
                    {{ $t("infos.livraison.minimumLivraison") }}
                    <span class="info-bold">{{
                      montantMinimumPourLivraisonFormated
                    }}</span>
                    <br />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="footer-modal" style="display: none"></div>
        </template>
        <div class="row modal-calendar-footer" v-if="clickedDate !== null">
          <div class="col">
            <h2
              id="resume-date"
              class="resume-date"
              ref="resume-date"
              v-html="clickedDateFormated"
            ></h2>
            <p class="description-horaire">
              {{ $t("calendrier.click.sentence") }}
            </p>
          </div>
        </div>
        <!-- <div>Date sélectionnée : {{ formatedDate }}</div> -->
        <div v-if="errorMessage.length !== 0" class="row">
          <div class="col">
            <h2>{{ errorMessage }}</h2>
          </div>
        </div>

        <div v-if="selectedDate.length !== 0" class="selection-horaires row">
          <div :class="disponibleLivraison">
            <div class="selection-horaire-titre">
              <img class="titre-picto" :src="imgurl + 'retrait.png'" />
              <span class="titre-horaire" v-html="titreHoraireRetrait"></span>
            </div>
            <div class="selection-horaires-liste" v-if="retrait">
              <div class="selection-horaires-liste d-flex flex-wrap">
                <div
                  class="selection-horaires-block"
                  :class="disponibleRetraitClass(horaire)"
                  v-for="horaire in horaires.all"
                  @click="handleDateAndHoraire(horaire, true, $event)"
                  :key="horaire"
                >
                  {{ horaire }}h
                </div>
              </div>
            </div>
            <div class v-else>{{ errorMessageRetrait }}</div>
          </div>
          <div class="col-md-6" v-if="livraisonMagasin">
            <div class="selection-horaire-titre">
              <img class="titre-picto" :src="imgurl + 'livraison.png'" />
              <span class="titre-horaire" v-html="titreHoraireLivraison"></span>
            </div>
            <div
              class="selection-horaires-liste d-flex flex-wrap"
              v-if="livraisonPossibleJour"
            >
              <div
                class="selection-horaires-block"
                :class="disponibleLivraisonClass(horaire)"
                v-for="horaire in horaires.all"
                @click="handleDateAndHoraire(horaire, false, $event)"
                :key="horaire"
              >
                {{ horaire }}h
                <!-- <div class="break"></div> -->
              </div>
            </div>
            <div class v-else>{{ errorMessageLivraison }}</div>
          </div>
        </div>
        <div v-if="selectedRetrait !== null" class="recapitulatif-selection">
          <div class="row d-flex align-content-center justify-content-center">
            <div class="col-md-8">
              <div
                class="recapitulatif-selection-texte"
                v-html="recapSentence"
              ></div>
            </div>
            <div class="col-md-4">
              <div
                class="
                  recapitulatif-selection-bouton
                  d-flex
                  align-content-center
                  justify-content-center
                "
                @click="submitDate"
              >
                <div class="d-flex">
                  <img
                    class="valid-picto align-self-center"
                    :src="imgurl + 'valid.png'"
                  />
                  <div
                    class="recapitulatif-selection-bouton-txt align-self-center"
                  >
                    {{ $t("calendrier.recap.commande.submit") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-else>
      <h1>{{ $t("ie.title") }}</h1>
      <p>{{ $t("ie.description") }}</p>
      <b-modal
        id="modal-ie"
        ref="modal-ie"
        size="xl"
        centered
        static
        hide-header="true"
        hide-footer="true"
      >
        <p>{{ $t("ie.descriptionModal") }}</p>
        <div class="d-flex flex-wrap justify-content-around align-items-center">
          <a
            href="https://www.microsoft.com/en-us/edge?form=MA13DE&OCID=MA13DE"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'edge.png'"
              alt="edge"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Microsoft Edge
            </span>
          </a>
          <a
            href="https://www.google.fr/chrome/?brand=CHBD&gclid=EAIaIQobChMIl5ixxO7p5wIVWbvVCh2NqQrWEAAYASAAEgLrc_D_BwE&gclsrc=aw.ds"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'chrome.png'"
              alt="chrome"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Google Chrome
            </span>
          </a>
          <a
            href="https://www.mozilla.org/fr/firefox/new/"
            target="_blank"
            class="d-flex flex-column"
          >
            <img
              :src="imgurl + 'firefox.png'"
              alt="firefox"
              width="75"
              class="d-block mx-auto"
            />
            <span>
              Télécharger
              <br />Mozilla Firefox
            </span>
          </a>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  props: {
    locale: String,
    imgurl: String,
    shop: String,
    shopUrl: String,
    cookieDate: String,
    token: String,
    nomMagasin: String,
    retraitChoosen: String,
    livraison: String,
  },
  data() {
    return {
      livraisonMagasin: false,
      livraisonStation: "",
      clickedDate: null,
      periodeGratuiteStart: null,
      periodeGratuiteEnd: null,
      errorMessageLivraison: "",
      errorMessageRetrait: "",
      firstDayMonth: null,
      fraisPreparationRetrait: null,
      fraisRetrait: null,
      fraisPreparationLivraison: null,
      fraisLivraison: null,
      livraisonGratuiteDes: null,
      montantMinimumPourLivraison: null,
      driveLastHoraireRetrait: null,
      hover: false,
      orderToday: false,
      calendarPlugins: [dayGridPlugin, interactionPlugin, bootstrapPlugin],
      firstDay: 1,
      errorMessage: "",
      selectable: true,
      defaultDate: null,
      events: [],
      disponibles: [],
      stopLivraison: [],
      stopCommande: [],
      maxCommande: [],
      selectedDate: "",
      selectedRetrait: null,
      selectedHoraire: "",
      header: {
        left: "",
        center: "prev, title, next",
        right: "",
      },
      calendarApi: null,
      url: `../module/seq_magasins/`,
      cookieDateData: this.cookieDate,
      stopLivraisonSelected: false,
      retrait: false,
      livraisonPossibleJour: false,
      horaires: {
        all: [
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
        ],
        retrait: [],
        livraison: [],
      },
    };
  },
  computed: {
    disponibleLivraison: function () {
      let classes = {
        "col-md-12": true,
      };
      if (this.livraisonMagasin) {
        classes = {
          "col-md-6": true,
          "divider-md": true,
        };
      }
      return classes;
    },
    titreHoraireRetrait: function () {
      return (
        this.$t("horaires.titre.horaires") +
        ' <strong class="titre-mode">' +
        this.$t("horaires.titre.retrait") +
        "</strong>"
      );
    },
    titreHoraireLivraison: function () {
      return (
        this.$t("horaires.titre.horaires") +
        ' <strong class="titre-mode">' +
        this.$t("horaires.titre.livraison") +
        "</strong>"
      );
    },
    sentenceTitle: function () {
      let sentence = "";
      if (this.locale === "en") {
        sentence =
          '<span class="choice-title">Choose the day</span> for your order';
      }
      if (this.locale === "fr") {
        sentence =
          '<span class="choice-title">Choix du jour</span> de réception de la commande';
      }
      return sentence;
    },
    clickedDateFormated: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM";
      }
      moment.locale(this.locale);
      const clickedDateFormat = moment(this.clickedDate).format(format);
      return (
        this.$t("calendrier.click.order") +
        ' <strong class="date-selected-resume">' +
        this.$t("calendrier.click.for") +
        clickedDateFormat +
        "</strong>"
      );
    },
    periodeGratuiteFormated: function () {
      let format = "";
      if (this.locale === "en") {
        format = "YYYY-MM-DD";
      } else if (this.locale === "fr") {
        format = "DD/MM/YYYY";
      }
      moment.locale(this.locale);
      const dateFormatStart = moment(this.periodeGratuiteStart).format(format);
      const dateFormatEnd = moment(this.periodeGratuiteEnd).format(format);
      return (
        this.$t("calendrier.livraison.periodeGratuite.intro") +
        dateFormatStart +
        this.$t("calendrier.livraison.periodeGratuite.mid") +
        dateFormatEnd
      );
    },
    montantMinimumPourLivraisonFormated: function () {
      return this.montantMinimumPourLivraison + " €";
    },
    livraisonGratuiteDesFormated: function () {
      return this.livraisonGratuiteDes + " €";
    },
    fraisLivraisonFormated: function () {
      let fraisLivraisonStr = this.fraisLivraison + " €";
      if (this.fraisLivraison === 0) {
        fraisLivraisonStr = "Gratuit";
        if (this.locale === "en") {
          fraisLivraisonStr = "Free";
        }
      }
      return fraisLivraisonStr;
    },
    fraisPreparationLivraisonFormated: function () {
      let fraisPreparationLivraisonStr = this.fraisPreparationLivraison + " €";
      if (this.fraisPreparationLivraison === 0) {
        fraisPreparationLivraisonStr = "Offert";
        if (this.locale === "en") {
          fraisPreparationLivraisonStr = "Free";
        }
      }
      return fraisPreparationLivraisonStr;
    },
    fraisRetraitFormated: function () {
      let fraisRetraitStr = this.fraisRetrait + " €";
      if (this.fraisRetrait === 0) {
        fraisRetraitStr = "Gratuit";
        if (this.locale === "en") {
          fraisRetraitStr = "Free";
        }
      }
      return fraisRetraitStr;
    },
    fraisPreparationRetraitFormated: function () {
      let fraisPreparationRetraitStr = this.fraisPreparationRetrait + " €";
      if (this.fraisPreparationRetrait === 0) {
        fraisPreparationRetraitStr = "Offert";
      }
      return fraisPreparationRetraitStr;
    },
    dernierHorairePossibleDrive: function () {
      return (
        this.$t("calendrier.bouton.dernierhoraire.retrait") +
        " : " +
        this.driveLastHoraireRetrait +
        "h00"
      );
    },
    modeSelected: function () {
      let mode = "";
      this.retraitChoosen === "1"
        ? (mode = this.$t("calendrier.recap.commande.retrait"))
        : (mode = this.$t("calendrier.recap.commande.livraison"));
      return mode;
    },
    dateAndHourFormat: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM YYYY HH:mm";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM YYYY HH:mm";
      }
      let dateFormat = "";
      moment.locale(this.locale);
      if (this.cookieDateData !== "") {
        dateFormat = moment(this.cookieDateData).format(format);
      }
      return dateFormat;
    },
    recapSentence: function () {
      let mode = "";
      this.selectedRetrait
        ? (mode = this.$t("calendrier.recap.commande.retrait"))
        : (mode = this.$t("calendrier.recap.commande.livraison"));
      return (
        this.$t("calendrier.recap.commande.first") +
        ' <strong class="recap-important">' +
        mode +
        "</strong> " +
        this.$t("calendrier.recap.commande.second") +
        ' <strong class="recap-important">' +
        this.formatedDate +
        " " +
        this.$t("calendrier.recap.commande.third") +
        " " +
        this.selectedHoraire +
        "h</strong>"
      );
    },
    formatedDate: function () {
      let format = "";
      if (this.locale === "en") {
        format = "dddd, D MMMM YYYY";
      } else if (this.locale === "fr") {
        format = "dddd D MMMM YYYY";
      }
      let dateFormat = "";
      moment.locale(this.locale);
      if (this.cookieDateData !== "") {
        dateFormat = moment(this.cookieDateData).format(format);
      }
      return dateFormat;
    },
    formatedMagasinTitle: function () {
      return "Sherpa Supermarché" + " - " + this.nomMagasin;
    },
    quitPresta: function () {
      return this.$t("alert.headerConfirm") + " " + this.nomMagasin;
    },
    selectedDateWithHour: function () {
      return moment(this.selectedDate)
        .add(this.selectedHoraire, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    goto(refName) {
      const element = this.$refs[refName];
      element.scrollIntoView({ behavior: "smooth" });
    },
    getInformations: function (retrait, date) {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=getInfos`;
      if (retrait) {
        axios({
          method: "POST",
          url: url,
          withCredentials: true,
          params: {
            retrait: 1,
            action: "getInfos",
            date: date,
            token: this.token,
            shop: this.shop,
          },
        }).then(function (response) {
          const data = response.data;
          vueInstance.fraisPreparationRetrait = data.fraisPreparationRetrait;
          vueInstance.fraisRetrait = data.fraisRetrait;
        });
      }
      if (!retrait) {
        axios({
          method: "POST",
          url: url,
          withCredentials: true,
          params: {
            retrait: 0,
            action: "getInfos",
            date: date,
            token: this.token,
            shop: this.shop,
          },
        }).then(function (response) {
          const data = response.data;
          vueInstance.fraisPreparationLivraison =
            data.fraisPreparationLivraison;
          vueInstance.fraisLivraison = data.fraisLivraison;
          vueInstance.montantMinimumPourLivraison = data.minimumLivraison;
          vueInstance.livraisonGratuiteDes = null;
          if (typeof data.minimumLivraisonGratuite !== "undefined") {
            vueInstance.livraisonGratuiteDes = data.minimumLivraisonGratuite;
          }
          vueInstance.montantMinimumPourLivraison = null;
          if (typeof data.minimumLivraison !== "undefined") {
            vueInstance.montantMinimumPourLivraison = data.minimumLivraison;
          }
          if (typeof data.periodeLivraisonGratuite !== "undefined") {
            vueInstance.periodeGratuiteStart =
              data.periodeLivraisonGratuite.start;
            vueInstance.periodeGratuiteEnd = data.periodeLivraisonGratuite.end;
          }
        //   vueInstance.livraisonStation = data.zoneLivraison;
        });
      }
    },
    handleDateAndHoraire: function (horaire, retrait, event) {
      // check si horaire possible...
      if (retrait) {
        if (this.isDisponibleRetrait(horaire)) {
          // très bourrin js vanilla
          const lastSelected = document.querySelectorAll("div.selected");
          if (lastSelected.length > 0) {
            lastSelected.forEach(function (element) {
              element.classList.remove("selected");
            });
          }
          event.target.className += " selected";
          this.selectDateAndHoraire(horaire, retrait);
        }
      }
      if (!retrait) {
        if (this.isDisponibleLivraison(horaire)) {
          // très bourrin js vanilla
          const lastSelected = document.querySelectorAll("div.selected");
          if (lastSelected.length > 0) {
            lastSelected.forEach(function (element) {
              element.classList.remove("selected");
            });
          }
          event.target.className += " selected";
          this.selectDateAndHoraire(horaire, retrait);
        }
      }
    },
    goToToday: function () {
      const today = moment().format("YYYY-MM-DD");
      this.calendarApi.select(today);
      this.handleDateClick({ dateStr: today });
    },
    submitDate: function () {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=setDateThirdCall`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: this.selectedDateWithHour,
          action: "setDateThirdCall",
          token: this.token,
          shop: this.shop,
          retrait: this.selectedRetrait,
        },
      }).then(function (response) {
        if (response.data.success) {
          console.log("ok");
          vueInstance.cookieDateData = vueInstance.selectedDateWithHour;
          vueInstance.$refs["modal-select-date"].hide();
          location.reload();
        } else {
          alert("pas ok");
        }
      });
    },
    selectDateAndHoraire: function (horaire, retrait = true) {
      this.selectedRetrait = retrait;
      this.selectedHoraire = horaire;
    },
    isDisponibleLivraison: function (heure) {
      let disponibleBool = false;
      for (let index = 0; index < this.horaires.livraison.length; index++) {
        const horaire = this.horaires.livraison[index];
        if (heure === horaire) {
          disponibleBool = true;
          break;
        }
      }
      return disponibleBool;
    },
    isDisponibleRetrait: function (heure) {
      let disponibleBool = false;
      for (let index = 0; index < this.horaires.retrait.length; index++) {
        const horaire = this.horaires.retrait[index];
        if (heure === horaire) {
          disponibleBool = true;
          break;
        }
      }
      return disponibleBool;
    },
    disponibleRetraitClass: function (heure) {
      let breakHoraireArr = ["8", "14"];
      let disponibleBool = false;
      let breakHoraireBool = false;
      for (let index = 0; index < this.horaires.retrait.length; index++) {
        const horaire = this.horaires.retrait[index];
        if (heure === horaire) {
          disponibleBool = true;
        }
        if (heure === breakHoraireArr[0]) {
          breakHoraireBool = true;
        }
        if (heure === breakHoraireArr[1]) {
          breakHoraireBool = true;
        }
      }
      return {
        disponible: disponibleBool,
        "break-wrap": breakHoraireBool,
      };
    },
    disponibleLivraisonClass: function (heure) {
      let breakHoraireArr = ["8", "14"];
      let disponibleBool = false;
      let breakHoraireBool = false;
      for (let index = 0; index < this.horaires.livraison.length; index++) {
        const horaire = this.horaires.livraison[index];
        if (heure === horaire) {
          disponibleBool = true;
        }
        if (heure === breakHoraireArr[0]) {
          breakHoraireBool = true;
        }
        if (heure === breakHoraireArr[1]) {
          breakHoraireBool = true;
        }
      }
      return {
        disponible: disponibleBool,
        "break-wrap": breakHoraireBool,
      };
    },
    handleDateClick(info) {
      const vueInstance = this;
      this.selectedRetrait = null;
      this.selectedHoraire = null;
      this.selectedDate = "";
      this.clickedDate = info.dateStr;
      const url = `${this.url}ajax?ajax=true&action=getDatesSecondCall`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: info.dateStr,
          action: "getDatesSecondCall",
          token: this.token,
          shop: this.shop,
        },
      }).then(function (response) {
        const data = response.data;
        if (data.ok) {
          vueInstance.errorMessage = "";
          vueInstance.errorMessageLivraison = "";
          vueInstance.errorMessageRetrait = "";
          if (data.retrait) {
            vueInstance.retrait = true;
            vueInstance.horaires.retrait = data.horairesRetrait;
            vueInstance.getInformations(true, info.dateStr);
          } else {
            vueInstance.retrait = false;
            if (data.messages !== undefined) {
              vueInstance.errorMessageRetrait = vueInstance.$t(
                "message." + data.messages.retrait[0]
              );
            }
            vueInstance.horaires.retrait = [];
          }
          if (data.livraison) {
            vueInstance.livraisonPossibleJour = true;
            vueInstance.horaires.livraison = data.horairesLivraison;
            vueInstance.getInformations(false, info.dateStr);
          } else {
            vueInstance.livraisonPossibleJour = false;
            if (data.messages !== undefined) {
              vueInstance.errorMessageLivraison = vueInstance.$t(
                "message." + data.messages.livraison[0]
              );
            }
            vueInstance.horaires.livraison = [];
          }
          vueInstance.selectedDate = info.dateStr;
          vueInstance.cookieDateData = info.dateStr;
          vueInstance.goto("resume-date");
        } else {
          vueInstance.errorMessage = vueInstance.$t(
            "message." + data.messages.all[0]
          );
        }
      });
      // this.checkEvents(info);
    },
    hideModal() {
      this.$refs["modal-backPortail"].hide();
    },
    handleSelect(selectionInfo) {
      const oneDay = moment(selectionInfo.startStr)
        .add(1, "days")
        .format("YYYY-MM-DD");
      if (oneDay !== selectionInfo.endStr) {
        // const info = {
        //   dateStr: selectionInfo.startStr,
        // };
        // this.checkEvents(info);
        this.calendarApi.select(selectionInfo.startStr);
      }
    },
    checkEvents(info) {
      this.selectedDate = "";
      if (this.disponibles.includes(info.dateStr) === false) {
        alert(
          "Cette date n'est pas disponible, veuillez en choisir une non grisée"
        );
      } else if (this.stopLivraison.includes(info.dateStr)) {
        this.stopLivraisonSelected = true;
        this.selectedDate = info.dateStr;
        alert("Retrait en magasin uniquement pour cette journée");
      } else if (this.stopCommande.includes(info.dateStr)) {
        alert("Commande impossible ce jour");
      } else {
        this.cookieDateData = info.dateStr;
        this.selectedDate = info.dateStr;
      }
    },
    handleSubmit() {
      const url = `${this.url}ajax?ajax=true&action=setDate`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: this.selectedDate,
          action: "setDate",
          token: this.token,
          idShop: this.shop,
        },
      }).then(function (response) {
        if (response.data.success) {
          console.log("ok");
        } else {
          alert("pas ok");
        }
      });
      this.cookieDateData = this.selectedDate;
      this.$refs["modal-select-date"].hide();
    },
    leavePresta() {
      // on vire les cookies
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=removeCookies`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          action: "removeCookies",
        },
      }).then(function () {
        const baseUrl = window.location.origin;
        let urlRefresh = baseUrl + `/magasins`;
        if (vueInstance.locale === "en") {
          urlRefresh = baseUrl + `/en/stores`;
        }
        return (window.location.href = urlRefresh);
      });
    },
    loadModal() {
      this.loadCalendar();
    },
    loadCalendar() {
      // const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getDates`;
      const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getDatesFirstCall`;
      axios.get(url).then((response) => {
        this.livraisonStation = response.data.zoneLivraison;
        const dates = response.data;
        this.disponibles = dates.disponible;
        let defaultDate = moment().format("YYYY-MM-DD");
        if (this.disponibles.includes(defaultDate) === false) {
          defaultDate = this.disponibles[0];
        }
        const firstDateIndisponible = moment(
          this.disponibles[this.disponibles.length - 1]
        )
          .add(1, "days")
          .format("YYYY-MM-DD");
        this.events = [
          {
            start: this.disponibles[0],
            end: firstDateIndisponible,
            editable: false,
            classNames: ["dateIndisponible"],
            rendering: "inverse-background",
            selectable: false,
          },
          {
            daysOfWeek: [0, 6], //Sundays and saturdays
            rendering: "background",
            overLap: false,
            allDay: true,
          },
        ];
        if (dates.stopCommande !== null) {
          this.stopCommande = dates.stopCommande;
          // const stopCommandeFin = moment(
          //   this.stopCommande[this.stopCommande.length - 1]
          // ).add(1, "days");
          // this.events.push({
          //   start: this.stopCommande[0],
          //   end: stopCommandeFin.format("YYYY-MM-DD"),
          //   editable: false,
          //   title: "Stop commande",
          //   rendering: "background",
          //   // backgroundColor: "#7f7f7f",
          //   classNames: ["dateIndisponible"],
          // });
        }
        if (dates.stopLivraison !== null) {
          this.stopLivraison = dates.stopLivraison;
          // const stopLivraisonFin = moment(
          //   this.stopLivraison[this.stopLivraison.length - 1]
          // ).add(1, "days");
          // this.events.push({
          //   start: this.stopLivraison[0],
          //   end: stopLivraisonFin.format("YYYY-MM-DD"),
          //   editable: false,
          //   title: "Stop livraison",
          //   rendering: "background",
          //   // backgroundColor: "#7f7f7f",
          //   classNames: ["dateIndisponible"],
          // });
        }
        if (dates.maxCommande !== null) {
          this.maxCommande = dates.maxCommande;
          // il faut boucler sur les jours, on ne fait pas une période !
          // for (let index = 0; index < this.maxCommande.length; index++) {
          //   const maxCommandeDate = this.maxCommande[index];
          //   this.events.push({
          //     start: maxCommandeDate,
          //     end: maxCommandeDate,
          //     editable: false,
          //     title: "Max commande atteint",
          //     rendering: "background",
          //     classNames: ["dateIndisponible"],
          //   });
          // }

          // this.events.push({
          //   start: this.stopLivraison[0],
          //   end: stopLivraisonFin.format("YYYY-MM-DD"),
          //   editable: false,
          //   title: "Stop livraison",
          //   rendering: "background",
          //   backgroundColor: "#bdbdbd",
          //   classNames: ["stopLivraison"],
          // });
        }
        if (!this.cookieDateData) {
          this.calendarApi.gotoDate(defaultDate);
        } else {
          this.calendarApi.gotoDate(this.cookieDateData);
          // this.calendarApi.select(this.cookieDateData);
        }
      });
    },
    isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf("MSIE ");
      // eslint-disable-next-line no-useless-escape
      return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    },
    isOrderTodayPossible() {
      const vueInstance = this;
      const url = `${this.url}ajax?ajax=true&action=checkDateDrive`;
      axios({
        method: "POST",
        url: url,
        withCredentials: true,
        params: {
          date: moment().format("YYYY-MM-DD"),
          action: "checkDateDrive",
          token: this.token,
          shop: this.shop,
        },
      }).then(function (response) {
        const data = response.data;
        vueInstance.orderToday = data.ok;
        vueInstance.driveLastHoraireRetrait = data.dernierHoraireRetrait;
      });
    },
    loadPicto() {
      const vueInstance = this;
      // appel ajax pour avoir les retraits / livraison du mois en cours
      const url = `${this.url}ajax?ajax=true&shop=${this.shop}&action=getPictos`;
      axios({
        method: "GET",
        url: url,
        withCredentials: true,
        params: {
          firstDayMonth: this.firstDayMonth,
          idShop: this.shop,
        },
      }).then(function (response) {
        const responseData = response.data;
        const retraitArr = responseData.retrait;
        const livraisonArr = responseData.livraison;
        if (retraitArr !== null) {
          vueInstance.appendPicto(retraitArr);
        }
        if (livraisonArr !== null) {
          vueInstance.appendPicto(livraisonArr, false);
        }
      });
    },
    appendPicto(arr, retrait = true) {
      let picto = "retrait";
      if (!retrait) {
        picto = "livraison";
      }
      for (let index = 0; index < arr.length; index++) {
        const date = arr[index];
        const selector = `.fc-day-top[data-date="${date}"]`;
        const found = document.querySelector(selector);
        if (found !== null) {
          const htmlExistantStr = found.innerHTML;
          const newHtmlStr = `<span class="picto-cal"><img src="${this.imgurl}${picto}.png" title="${picto} disponible à cette date"></span> ${htmlExistantStr}`;
          found.innerHTML = newHtmlStr;
        }
      }
    },
    handleNewRender() {
      if (this.calendarApi === null) {
        this.calendarApi =
          this.$refs["modal-select-date"].$children[0].getApi();
      }
      const dayRenderedMoment = moment(this.calendarApi.getDate());
      const firstDayMonthRendered = dayRenderedMoment
        .startOf("month")
        .startOf("day")
        .format("YYYY-MM-DD");
      this.firstDayMonth = firstDayMonthRendered;
      this.loadPicto();
    },
  },
  mounted() {
    this.livraisonMagasin = Boolean(Number(this.livraison));
    if (!this.isIE()) {
      if (this.cookieDateData === "") {
        this.loadCalendar();
        // this.loadPicto();
        this.$refs["modal-select-date"].show();
      }
      this.isOrderTodayPossible();
    } else {
      this.$refs["modal-ie"].show();
    }
  },
};
</script>

<style lang='scss'>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/bootstrap/main.css";
@import url("https://fonts.googleapis.com/css?family=Advent+Pro:100,200,300,400,500,600,700|Open+Sans:300,400,600,700,800&display=swap");
$sh_opensans: "Open Sans", sans-serif;
$grey: #666;
#seq_calendrier {
  font-family: $sh_opensans;
}
#modal-select-date___BV_modal_body_ .fc-header-toolbar > .fc-center {
  display: flex;
  align-items: center;

  h2 {
    min-width: 220px;
    margin-left: 0;
    font-size: 1.5rem;
    color: #004338;
    text-align: center;
  }

  .fc-prev-button,
  .fc-next-button {
    color: #004338;
    background-color: transparent;
    border-color: transparent;

    &:focus {
      box-shadow: none;
    }

    > span {
      font-size: 2rem;
    }
  }
}

.fc-bgevent {
  background: transparent;
  opacity: 1;
}

.fc-sat:not(.fc-day-header),
.fc-sun:not(.fc-day-header) {
  background: #f5f5f5;
}

.dateIndisponible {
  color: #fff;
  background: rgba(#7f7f7f, 0.85);
}

.fc-highlight {
  background: #004338;
  opacity: 1;
}

.fc-dayGrid-view .fc-day-number {
  padding: 5px 10px 0 0;
}

#modal-select-date___BV_modal_content_ {
  padding: 25px 16px 35px;
  @media screen and (max-width: 768px) {
    padding: 25px 10px 35px;
  }
}

#modal-select-date___BV_modal_title_ {
  width: 100%;
  padding: 0;
  font-size: 2rem;
  font-weight: bold;
  color: #004338;
  text-align: center;
}

#modal-select-date___BV_modal_header_,
#modal-select-date___BV_modal_footer_ {
  padding: 0 15px;
  border: 0;
}

#modal-select-date___BV_modal_footer_ > button {
  padding: 10px 30px;
  background: #15889a;
  text-transform: uppercase;
  border: 0;
  border-radius: 0;
}

.fc-head-container {
  border-width: 0 !important;
}

.fc-toolbar.fc-header-toolbar {
  justify-content: center !important;
}

.fc-day-header {
  border-width: 0 !important;
  text-align: right !important;
  text-transform: capitalize;
  font-weight: normal;
  border-color: transparent !important;
}

.fc-today .fc-day-number {
  background: red;
  border-radius: 50%;
  color: white;
  vertical-align: middle;
  line-height: 1;
  text-align: center;
  margin: 5px;
  padding: 5px;
  width: 15px;
  height: 15px;
}

.fc-scroller.fc-day-grid-container {
  height: auto !important;
}

#modal-ie .modal-body {
  padding: 100px 150px !important;
}

#modal-ie .modal-body a {
  margin-top: 30px;
  color: #000;
}

@media screen and (max-width: 768px) {
  #modal-ie .modal-body {
    padding: 40px 10px !important;
  }
}

.selection-horaires-block {
  width: 72px;
  background-color: #ccc;
  color: #333;
  border-top: 0.25px solid;
  border-right: 0.125px solid;
  border-bottom: 0.25px solid;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  border-color: #808080;
  &.disponible {
    background-color: #fff;
    cursor: pointer;
    &:hover {
      background-color: darken($color: #fff, $amount: 10%);
    }
  }
  &.selected {
    background-color: #004338;
    color: #fff;
    &:hover {
      background-color: #004338;
    }
  }
}

.break {
  flex-basis: 100%;
  height: 0;
}

.recapitulatif-selection {
  background-color: #004338;
  padding: 2rem;
  color: #fff;
  .recapitulatif-selection-texte {
    font-size: 1.563rem;
    padding-left: 5rem;
    .recap-important {
      font-weight: bold;
    }
  }
  .recapitulatif-selection-bouton {
    text-align: left;
    cursor: pointer;
    height: 100%;
    background-color: #fff;
    .valid-picto {
      padding: 0 1.25rem;
    }
    .recapitulatif-selection-bouton-txt {
      font-weight: bold;
      color: #000;
    }
    &:hover {
      background: darken($color: #fff, $amount: 10%);
    }
  }
}

.infos-date {
.zone_livraison {
    color: #e4004d;
    font-weight: 700;
    font-size: 24px;
    line-height: 34px;
}
  margin-top: 4.5rem;
  font-size: 0.813rem;
  text-align: justify;
  color: $grey;
  .info-bold {
    font-weight: bold;
  }
  .infos-retrait {
    margin-top: 1rem;
  }
  .infos-livraison {
    margin-top: 1rem;
  }
  h5 {
    font-family: $sh_opensans;
    font-size: 1rem;
    font-weight: bold;
  }
}

.titre-picto {
  margin-right: 0.25rem;
}

.selection-horaire-titre {
  font-size: 0.938rem;
  padding: 0.5rem 0 0.5rem 0;
  text-align: left;
  .titre-horaire {
    color: $grey;
    .titre-mode {
      font-weight: bold;
    }
  }
  .titre-picto {
    margin-right: 1rem;
  }
}

.bouton-drive {
  @media (min-width: 768px) {
    margin-top: 95px;
  }
  text-align: left;
  background-color: #004338;
  color: #fff;
  cursor: pointer;
  padding: 0.5rem 0;
  border-radius: 0.25rem;
  &:hover {
    background-color: darken($color: #004338, $amount: 10%);
  }
  .titre-picto {
    margin-right: 1rem;
  }
  .drive-last-horaire {
    font-size: 0.85rem;
    font-style: italic;
  }
}

.picto-cal {
  cursor: pointer;
  float: left;
  padding-top: 5px;
  margin-left: 4px;
  img {
    width: 1.5rem;
  }
}

.divider-md {
  @media (min-width: 768px) {
    border-right: solid #d9d9d9;
  }
}

.break-wrap {
  page-break-before: always;
  border-left: 0.25px solid #808080;
}

.modal-title {
  font-family: $sh_opensans;
  color: $grey;
  .supermarket-title {
    font-size: 1.25rem;
  }
  .sentence-title {
    font-size: 1.563rem;
    .choice-title {
      color: #1a1a1a;
      font-weight: bold;
    }
  }
}

.modal-calendar-footer {
  color: $grey;
  margin-top: 2rem;
  .resume-date {
    font-family: $sh_opensans;
    .date-selected-resume {
      color: #1a1a1a;
    }
  }
  .description-horaire {
    font-size: 0.813rem;
    font-style: italic;
  }
}
</style>
